// src/views/turnos/TurnoView.js
import { useEffect, useState } from "react";
import { fetchTurnosSemanales } from "../../../controller/TurnoController";
import { useNavigate } from "react-router-dom";
import { Container, Table, Button } from "react-bootstrap";
import { PencilSquare, Plus } from "react-bootstrap-icons";

function TurnoView() {
  const [turnos, setTurnos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const obtenerTurnos = async () => {
      try {
        const data = await fetchTurnosSemanales();
        setTurnos(data);
      } catch (error) {
        console.error("Error al obtener los turnos semanales:", error);
      }
    };
    obtenerTurnos();
  }, []);

  const handleCreateTurno = () => {
    navigate("/turno/create");
  };

  const handleEditTurno = (turno) => {
    navigate("/turno/edit", {
      state: { turno },
    });
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Turnos</h1>
        <Button variant="primary" onClick={handleCreateTurno}>
          <Plus className="me-2" /> Crear Turno
        </Button>
      </div>


      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {turnos.map((turno) => (
            <tr key={turno.id}>
              <td>{turno.nombre}</td>
              <td>
                <Button
                  variant="light"
                  size="sm"
                  onClick={() => handleEditTurno(turno)}
                >
                  <PencilSquare color="blue" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>


    </Container>
  );
}

export default TurnoView;
